import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=6e3cff73&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=6e3cff73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cff73",
  null
  
)

export default component.exports